var PubSub = require("underpub-js");
var Wallop = require('Wallop');
var Equalizer = require('equalizer');
var loadTouchEvents = require('jquery-touch-events');
loadTouchEvents($);

var ImageGalleryModal = function(options){

  this.options = {
    $el: false
  };

  $.extend(true, this.options, options);

};

ImageGalleryModal.prototype.init = function(){

  var self = this;

  var slider = this.options.$el.find('.Wallop')[0]; // wallop takes a plain JS element, so use [0]
  this.wallop = new Wallop(slider);

  var imageId = 1;

  // add a class to our images so they show a pointer on hover
  $('[data-side-by-side-images], [data-wide-image], [data-tall-image], [data-full-width-image-slider]').each(function() {

    $(this).addClass('hover-pointer');

  });
  
  // go through and set data-image-id on images so we know what image to open on click
  $('[data-side-by-side-images] figure img, [data-wide-image] figure img, [data-tall-image] figure img, [data-full-width-image-slider] .slide-image').each(function() {
    
    // add IDs to images
    $(this).data('imageId', imageId++);

  });

  // handle opening the modal when an image is clicked
  $('[data-full-width-image-slider] .slide-image, [data-side-by-side-images] figure img, [data-wide-image] figure img, [data-tall-image] figure img').on('click', function() {

    var clickedImageId = $(this).data('imageId');

console.log('image click - open modal');
console.log('image id - ' + clickedImageId);

    self.openSliderToImage(clickedImageId);

  });
  
  // close modal on background click
  this.options.$el.find('.close-x').on('click', function() {
    self.closeSliderModal();
  });
  
  /*
  // dots navigation
  this.options.$el.find(".dots-nav span").on("click", function(){
    var goToSlide = $(this).data("slideIndex");

    self.wallop.goTo(goToSlide);
  });

  // update dots when slide changes
  var slideChange = function(event) {

    var activeSlideNum = event.detail.currentItemIndex;
    self.options.$el.find('.dots-nav span').removeClass('active');
    self.options.$el.find('[data-slide-index=' + activeSlideNum + ']').addClass('active');

  };

  this.wallop.on('change', slideChange);
  */

  // equalize wallop slide heights
  this.eq = new Equalizer('[data-image-gallery-modal] .Wallop .Wallop-item');

  PubSub.subscribe("resized", function(){
    console.log('align again');
    self.eq.align();
  });

  // previous and next buttons
  this.options.$el.find('.previous-slide').on('click', function() {

    self.wallop.previous();

  });

  this.options.$el.find('.next-slide').on('click', function() {

    self.wallop.next();

  });

  // swipe events
  this.options.$el.find('.Wallop').on('swiperight', function() {

    self.wallop.previous();
    
  });

  this.options.$el.find('.Wallop').on('swipeleft', function() {
    
    self.wallop.next();

  });

  // arrow key events
  $(document).keydown(function(e) {

    switch(e.which) {

      // escape
      case 27:
        self.closeSliderModal();
        break;

      // left
      case 37:
        self.wallop.previous();
        break;

      // right
      case 39:
        self.wallop.next();
        break;

    }

  });

};

ImageGalleryModal.prototype.openSliderToImage = function(imageId){

  var self = this;
console.log('open slider to image - ' + imageId);
  this.wallop.goTo(parseInt(imageId - 1));
  this.openSliderModal();

};

ImageGalleryModal.prototype.openSliderModal = function(imageId){

  this.eq.align();
  this.options.$el.removeClass('no-longer-shown').addClass('active');

};

ImageGalleryModal.prototype.closeSliderModal = function(imageId){

  this.options.$el.removeClass('active').addClass('no-longer-shown');

};

module.exports = ImageGalleryModal;
